import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarClock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m1.433 6.423.709 4.019a2 2 0 0 0 2.317 1.622l2.302-.406M1.433 6.423l-.101-.577a2 2 0 0 1 1.622-2.317l5.252-.926a2 2 0 0 1 2.317 1.622l.102.578zm9.234 1.35v1.56l1.386 1.387M15 9.333a4.333 4.333 0 1 1-8.667 0 4.333 4.333 0 0 1 8.667 0"
	})
});
export default SvgCalendarClock;
